// document.addEventListener('DOMContentLoaded', () => {
  
//   const productBlock = document.querySelector('fieldset.js.product-form__input.product-form__input--pill:last-of-type > legend.form__label');
//   //add console logging here
//   let isInjected = false;  

//   if (productBlock) {
    
//     const pbObserver = new MutationObserver((mutations) => {
//       mutations.forEach((mutation) => {

//         const kiwi = document.querySelector('div.ks-chart-container.sizing-chart-container.ks-container-with-modal');
//         //add console logging here
//         console.log("ST TEST change")
//         if (!kiwi && !isInjected) {
//           loadKiwiSizingChart();
//           isInjected = true;  
//           console.log('isInjected',isInjected)
//         }
//       });
//     });

//     pbObserver.observe(productBlock, 
//       { attributes: false, 
//         childList: true, 
//         subtree: true 
//       });

//     setInterval(() => {
//       const allCharts = document.querySelectorAll('div.ks-chart-container.sizing-chart-container.ks-container-with-modal');
//       console.log("allCharts.length",allCharts.length)
//       if (allCharts.length === 0) {
//         console.log("ST TEST interval")
        
//         loadKiwiSizingChart();
//         isInjected = true;
//       } else if (allCharts.length > 1) {
//         allCharts.forEach((chart, index) => {
//           if (index > 0) chart.remove();
//         });
//       } else {
//         isInjected = false;  
//       }
//           console.log('iterval isInjected',isInjected)
      
//     }, 1000); 
//   } else {
//       //fallback if necessary goes here 
//     }
// });

function handleURLParamChange(){
  console.log("url change")
  setTimeout(() => {
    const kiwi = document.querySelector('div.ks-chart-container.sizing-chart-container.ks-container-with-modal');
    console.log("ST TEST change")
      if (!kiwi) {
        loadKiwiSizingChart();
      }
  }, "500");
}

const originalPushState = history.pushState;
const originalReplaceState = history.replaceState;

history.pushState = function() {
  originalPushState.apply(this, arguments);
  handleURLParamChange();
};

history.replaceState = function() {
  originalReplaceState.apply(this, arguments);
  handleURLParamChange();
};



setInterval(() => {
  const allCharts = document.querySelectorAll('div.ks-chart-container.sizing-chart-container.ks-container-with-modal');
  console.log("allCharts.length",allCharts.length)
  if (allCharts.length === 0) {
    // loadKiwiSizingChart();
    // isInjected = true;
  } else if (allCharts.length > 1) {
    allCharts.forEach((chart, index) => {
      if (index > 0) chart.remove();
    });
  } else {
    // isInjected = false;  
  }
}, 1000); 